var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swatch",style:(_vm.style)},[(_vm.name)?_c('h4',[_vm._v(_vm._s(_vm.name))]):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.label))]),_c('p',[_c('code',[_vm._v(_vm._s(_vm.color))])])])}
var staticRenderFns = []

export { render, staticRenderFns }